import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { CellContext } from '@tanstack/react-table';

export interface LocationListCityCellProps
  extends CellContext<GatewayLocationModel, GatewayLocationModel['city']> {}

export const LocationListCityCell = (
  props: LocationListCityCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
